import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Map, List } from 'immutable';
import { push } from 'react-router-redux';

import Loading from './Loading';
import { ModalActions } from '../actions/modal';
import { ElementActions } from '../actions/element';
import { PageActions } from '../actions/page';
import immutableCreatorSelector from '../selectors/immutableCreatorSelector';
import EntityNotFound from './EntityNotFound';
import StandardElement from './StandardElement/';
import { InlineEditorActions } from '../actions/inlineEditor';

import { notFoundSelector, isNotFound } from '../reducers/notFound';
import { currentProjectIdSelector } from '../reducers/projects';
import {
  shouldLoadElement,
  elementsLoadingSelector,
  elementsLoadedSelector,
  currentElementSelector,
  currentElementIdSelector,
} from '../reducers/elements';
import { currentElementTypeByElementSelector } from '../reducers/elementTypes';
import { elementCollapseStateSelector } from '../reducers/pages';
import {
  missingRelationshipsSelector,
  missingElementsSelector,
} from '../reducers/relationships';
import { elementTagsSelector } from '../reducers/tags';
import { iconsSelector, getIcon } from '../reducers/icons';
import {
  taskTypeIdSelector,
  milestoneTypeIdSelector,
} from '../reducers/elementTypes';
import {
  currentUserSelector,
  userModeSelector,
  getUserModeByProjectId,
} from '../reducers/users';

import '../styles/ProjectTab.css';

class Element extends Component {
  static propTypes = {
    element: PropTypes.instanceOf(Map),
    dispatch: PropTypes.func,
    icon: PropTypes.object,
    currentElementType: PropTypes.instanceOf(Map),
    collapseState: PropTypes.instanceOf(Map),
    tags: PropTypes.instanceOf(List),
    currentProjectId: PropTypes.string,
    currentElementId: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.toggleSelectIconModal = this.toggleSelectIconModal.bind(this);
    this.toggleReducerState = this.toggleReducerState.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  onSave(value, formUid) {
    const { currentElementId, dispatch } = this.props;

    dispatch(ElementActions.renameElement(currentElementId, value)).then(() => {
      if (formUid) {
        dispatch(InlineEditorActions.unsetInlineEditState(formUid));
      }
    });
  }

  confirmDelete() {
    const { dispatch, element } = this.props;

    const name = element.get('name');

    dispatch(
      ModalActions.toggleModal({
        name: 'DeleteConfirmationModal',
        options: {
          deleteType: 'element',
          handleDelete: this.handleDelete,
          name,
        },
      }),
    );
  }

  handleDelete() {
    const {
      currentElementId,
      dispatch,
      currentProjectId,
      selectElement,
      optionalCallback,
    } = this.props;

    dispatch(
      ElementActions.deleteElement(
        {
          id: currentElementId,
          projectId: currentProjectId,
        },
        true,
      ),
    ).then(() => {
      if (selectElement) selectElement(-1);
      else dispatch(push(`/project/${currentProjectId}`));

      if (optionalCallback) {
        optionalCallback();
      }
    });
  }

  toggleSelectIconModal(elementId, reroute) {
    const { dispatch } = this.props;

    dispatch(
      ModalActions.toggleModal({
        name: 'IconSelectModal',
        options: {
          componentType: 'elements',
          componentId: elementId,
        },
      }),
    )
  }

  toggleReducerState(key, elementId, currentState) {
    const { dispatch } = this.props;
    const reducerType = 'element';

    dispatch(
      PageActions.toggleState(key, elementId, reducerType, currentState),
    );
  }

  render() {
    const { element, selectElement, userMode } = this.props;
    return <div className="inner-tab-container">
      <StandardElement
          toggleReducerState={this.toggleReducerState}
          toggleSelectIconModal={this.toggleSelectIconModal}
          onSave={this.onSave}
          confirmDelete={this.confirmDelete}
          selectElement={selectElement}
          userMode={userMode}
          rootElement={!element.get('parent_id')}
          {...this.props}
        />
      </div>;
  }
}

const ElementContainerSelector = immutableCreatorSelector(
  [
    notFoundSelector,
    elementCollapseStateSelector,
    currentElementSelector,
    currentElementIdSelector,
    currentElementTypeByElementSelector,
    currentProjectIdSelector,
    currentUserSelector,
    missingElementsSelector,
    missingRelationshipsSelector,
    elementTagsSelector,
    iconsSelector,
    taskTypeIdSelector,
    milestoneTypeIdSelector,
    elementsLoadingSelector,
    elementsLoadedSelector,
    userModeSelector,
  ],
  (
    notFound,
    collapseState,
    currentElement,
    currentElementId,
    currentElementTypeByElement,
    currentProjectId,
    currentUser,
    missingElements,
    missingRelationships,
    tags,
    icons,
    taskTypeId,
    milestoneTypeId,
    elementsLoading,
    elementsLoaded,
  ) => {
    return {
      notFound: isNotFound(notFound, 'elements', currentElementId),
      collapseState,
      icon: getIcon(currentElement, currentElementTypeByElement, icons),
      currentElement,
      currentElementId,
      currentElementType: currentElementTypeByElement,
      currentProjectId,
      currentUser,
      missingElements,
      missingRelationships,
      tags,
      taskTypeId,
      milestoneTypeId,
      shouldLoadElementCheck: shouldLoadElement(
        elementsLoading,
        elementsLoaded,
        currentElementId,
      ),
      userMode: getUserModeByProjectId(currentUser, currentProjectId),
    };
  },
);

@connect(ElementContainerSelector)
export default class ElementContainer extends Component {
  static propTypes = {
    currentElement: PropTypes.instanceOf(Map),
    dispatch: PropTypes.func,
    currentProjectId: PropTypes.string,
    missingElements: PropTypes.instanceOf(List),
    currentElementType: PropTypes.object,
    missingRelationships: PropTypes.bool,
    notFound: PropTypes.bool,
    currentElementId: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.dispatchGetElement = this.dispatchGetElement.bind(this);
    this.dispatchGetMissingElements = this.dispatchGetMissingElements.bind(
      this,
    );
    this.elementNotLoadedCheck = this.elementNotLoadedCheck.bind(this);
  }

  componentDidMount() {
    const {
      missingElements,
      currentElementId,
      shouldLoadElementCheck,
    } = this.props;

    if (shouldLoadElementCheck) {
      this.dispatchGetElement(currentElementId);
      this.dispatchGetMissingElements(missingElements);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.currentElement.get('id') &&
      nextProps.shouldLoadElementCheck
    ) {
      if (nextProps.missingRelationships) {
        this.dispatchGetElement(nextProps.currentElement.get('id'));
      }

      this.dispatchGetMissingElements(nextProps.missingElements);
    }
  }

  dispatchGetElement(elementId) {
    const { dispatch } = this.props;

    dispatch(
      ElementActions.getElement(elementId, {
        fields: [
          'children',
          'parent',
          'childrenOfChildren',
          'consumesFrom',
          'providesTo',
        ],
      }),
    );
  }

  dispatchGetMissingElements(missingElements) {
    const { dispatch, currentProjectId } = this.props;

    if (missingElements.size) {
      dispatch(
        ElementActions.getBulkElements(currentProjectId, missingElements, {
          fields: [
            'children',
            'parent',
            'childrenOfChildren',
            'consumesFrom',
            'providesTo',
          ],
        }),
      );
    }
  }

  elementNotLoadedCheck() {
    const {
      currentElement,
      missingElements,
      missingRelationships,
    } = this.props;

    return (
      currentElement.size === 0 ||
      missingElements.size !== 0 ||
      missingRelationships
    );
  }

  render() {
    const { currentElement, notFound, currentElementId } = this.props;

    if (notFound) {
      return <EntityNotFound type="element" id={currentElementId} />;
    }
    if (this.elementNotLoadedCheck()) {
      return <Loading loadingMessage="Your element is being loaded..." />;
    }
    return <Element element={currentElement} {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Element.js